import { Navigate, Outlet, useLocation } from "react-router-dom";
import { normaliseAppPath } from "../../appRedirects";

const ALLOWED_ROUTES = [
  "/",
  "/in-season/in-season-review",
  "/in-season/in-season-forecast/forecast",
  "/in-season/in-season-forecast/manage-cubes",
  "/in-season/in-season-forecast/manage-stores",
  "/in-season/in-season-forecast/otb",
  "/in-season/in-season-forecast/summary",
  "/lifecycle-management/tradex/trade-actions",
  "/lifecycle-management/tradex/playbook",
  "/assortment/purchase-review",
  "/pre-season/budget/budget",
  "/pre-season/budget/summary",
  "/pre-season/budget/manage-cubes",
  "/admin",
  "/your-access",
  "/settings",
  "/settings/access",
  "/settings/general",
  "/settings/members",
  "/settings/view-roles",
  "/settings/in-season",
  "/operations",
  "/operations/integration-runs",
  "/forbidden"
];
// Routes whose path carries an id, so they cannot be listed exactly.
const ALLOWED_ROUTE_PREFIXES = ["/restore-feedback/"];

export function ProductionRedirect() {
  const location = useLocation();

  // Only redirect in the production deployment
  if (import.meta.env.VITE_ENVIRONMENT === "production") {
    // Match the way the router does, so a path it serves is never bounced.
    const matchPath = normaliseAppPath(location.pathname);
    const isAllowedRoute =
      ALLOWED_ROUTES.includes(matchPath) ||
      ALLOWED_ROUTE_PREFIXES.some((prefix) => matchPath.startsWith(prefix));

    if (!isAllowedRoute) {
      return (
        <Navigate
          to={
            matchPath === "/pre-season/budget"
              ? "/pre-season/budget/budget"
              : "/"
          }
          replace
        />
      );
    }
  }

  return <Outlet />;
}
